<template>
  <div class="unit-filter grid-column ai-c jc-c">
    <button
      v-for="(item, idx) in hvac"
      :key="idx"
      type="button"
      :class="['unit-btn', selectedUnit.uid === item.uid ? 'active' : '']"
      @click="changeUnit(item)"
    >
      Unit {{ idx + 1 }}: {{ item.manufacturer }}
    </button>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import { mapState } from 'vuex';

export default {
  name: 'HvacUnitTab',
  mixins: [customerDetailMixin],
  computed: {
    ...mapState({
      selectedUnit: (state) => state.customerDetail.selectedUnit,
    }),
  },
  methods: {
    changeUnit(hvac) {
      window.scrollTo(0, 0);
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'selectedUnit',
        value: hvac,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.unit-filter {
  top: 100px;
  z-index: 1;
  .unit-btn {
    background-color: #E5E5E5;
    color: #6C6C6C;
    padding: 4px 30px;
    font-size: 1rem;
    font-weight: 500;
    border: 4px solid $N10;
    &.active {
      background-color: #FAFAFA;
      color: #333;
      font-weight: 700;
    }
    &:first-child {
      border-bottom-left-radius: 6px;
      border-top-left-radius: 6px;
    }
    &:last-child {
      border-bottom-right-radius: 6px;
      border-top-right-radius: 6px;
    }
  }
}

</style>
